namespace TabAurous.Finance {
    export interface AccountingPeriodDetailsRow {
        DetailId?: number;
        PeriodId?: number;
        VoucherTypeId?: number;
        VoucherTypeName?: string;
        TypeOfVoucher?: string;
        CompanyId?: number;
        IsClosed?: boolean;
    }

    export namespace AccountingPeriodDetailsRow {
        export const idProperty = 'DetailId';
        export const localTextPrefix = 'Finance.AccountingPeriodDetails';
        export const deletePermission = 'Finance:AccountingPeriod:Delete';
        export const insertPermission = 'Finance:AccountingPeriod:Add';
        export const readPermission = '*';
        export const updatePermission = 'Finance:AccountingPeriod:Edit';

        export declare const enum Fields {
            DetailId = "DetailId",
            PeriodId = "PeriodId",
            VoucherTypeId = "VoucherTypeId",
            VoucherTypeName = "VoucherTypeName",
            TypeOfVoucher = "TypeOfVoucher",
            CompanyId = "CompanyId",
            IsClosed = "IsClosed"
        }
    }
}
